/* eslint-disable camelcase */
import { PaymentMethodsCommandNames, sendRioEvent, SpecType, SubType, ValidationManager } from '@chegg/commerce-utils';
var getMopError = ValidationManager.ValidationMessages.getMopError;
import { Component } from '../../../constants/CallbackConstants';
import { StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { updateMOPError } from '../PaymentState.actions';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
/**
 * handleUpdateMopAPI Failure handles error failure due to API failure (e.g. 403)
 */

export var handleUpdateMopAPIFailure = function handleUpdateMopAPIFailure(params) {
  var response = params.response,
    dispatch = params.dispatch,
    rioNamespace = params.rioNamespace;
  var errors = response.errors;
  var message_name = getMopError('pmt30300').message_name;
  var message_detail = getMopError('pmt30300').message_detail;
  var message_id = getMopError('pmt30300').message_id;

  // for rio
  var message = errors && errors[0] && errors[0].message != '' ? errors[0].message : message_detail;
  dispatch(updateMOPError({
    message: {
      text: message_detail,
      type: StatusTypes.ERROR,
      code: 'pmt30300'
    },
    rawData: errors
  }));

  // RIO Logging
  sendRioEvent({
    info: message_name,
    specType: SpecType.NOTIFICATION,
    subType: SubType.ERROR,
    callback: sendRioEventCallback,
    namespace: rioNamespace,
    message_detail: "Credit Card: ".concat(message),
    message_id: message_id
  });
  doFireStatusUpdate([{
    status: StatusTypes.ERROR,
    command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
    payload: {
      component: Component.PAYMENT_MODULE_LOGIC,
      errors: errors
    }
  }]);
  sendNewRelicMessage("UpdateMopLogic: ".concat(JSON.stringify(errors)));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/handleUpdateMopAPIFailure.js
// module id = 4398
// module chunks = 11